export const SET_PROJECT_FIELD = 'SET_PROJECT_FIELD';

export function setProjectField(key, value) {
    return { type: SET_PROJECT_FIELD, key, value };
}
